import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useEnglishText } from "../../../text/useEnglishText.js";
import { getAuditLogs } from "../../../services/auditLogService";
import DocumentsList from "../../../components/layout/DocumentsList";
import AdminPageHeader from "../../../components/common/AdminPageHeader";
import { Activity, RefreshCw } from "lucide-react";
import { Button } from "../../../components/ui/button";

function AuditLogs() {
  const { t } = useEnglishText();

  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await getAuditLogs();
      const list = Array.isArray(res) ? res : res?.logs || [];
      setLogs(list);
      setTotal(res?.total ?? list.length);

    } catch (err) {
      console.error("Failed to load audit logs:", err);
      setError(t("auditLogs.load_error", "Failed to load audit logs."));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelect = (row) => {
    // باز کردن جزئیات لاگ در صورت نیاز
    console.log("Selected log:", row?.raw || row);
  };

  return (
    <Box>
      <AdminPageHeader
        icon={Activity}
        title={t("auditLogs.title", "Audit Logs")}
        description={`${t("auditLogs.subtitle", "System activity and important changes")}${total > 0 ? ` • ${total} ${t("auditLogs.records", "records")}` : ""}`}
      />

      <DocumentsList
        data={logs}
        loading={loading}
        error={error}
        emptyTitle={t("auditLogs.empty", "No audit logs yet")}
        onSelect={handleSelect}
        page={page}
        pageSize={pageSize}
        paginateLocally
        onPageChange={(p) => setPage(p)}
        actions={<Button variant="outline" onClick={fetchLogs} disabled={loading}><RefreshCw aria-hidden="true" />{t("common.refresh", "Refresh")}</Button>}
      />
    </Box>
  );
}

export default AuditLogs;
